import { formatDisplayDate } from '@/utils/Date';

export const preventLeadingWhitespace = (
  event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
) => {
  const input = event.target as HTMLInputElement | HTMLTextAreaElement;
  // Check if the pressed key is a space and the cursor is at the start
  if (event.key === " " && input.selectionStart === 0) {
    event.preventDefault();
  }
};

export const extractTime = (dateStr: string) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const formatDateRange = (start: string, end: string) => {
  const startFormatted = formatDisplayDate(start.split('T')[0], '');
  const endFormatted = formatDisplayDate(end.split('T')[0], '');

  if (!startFormatted && !endFormatted) return '';
  if (!startFormatted) return endFormatted;
  if (!endFormatted) return startFormatted;

  return `${startFormatted} - ${endFormatted}`;
};
